import { render, staticRenderFns } from "./CmsApiTokens.vue?vue&type=template&id=46490d5f&scoped=true&lang=pug&"
import script from "./CmsApiTokens.vue?vue&type=script&lang=js&"
export * from "./CmsApiTokens.vue?vue&type=script&lang=js&"
import style0 from "./CmsApiTokens.vue?vue&type=style&index=0&id=46490d5f&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46490d5f",
  null
  
)

/* custom blocks */
import block0 from "./CmsApiTokens.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports